module.exports = __webpack_public_path__ + "img/ug343.90a02f0b.png";